// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1jhR-","header":"ReportDetails_header__21DM1","title":"ReportDetails_title__3n8hR","left":"ReportDetails_left__3P4SW"};